import { LayoutProps, rankWith, uiTypeIs } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';

import { getElements } from '../../../../../utils/DynamicForms';
import './style.scss';

type Props = LayoutProps;

const VerticalStepsLayout = (props: Props) => {
  return (
    <div className="tru-layout-vertical-steps">
      {getElements(props.uischema).map((element, index) => (
        <ResolvedJsonFormsDispatch {...props} uischema={element} key={index} />
      ))}
    </div>
  );
};

export const VerticalStepsEntry = {
  tester: rankWith(1, uiTypeIs('VerticalStepsLayout')),
  renderer: withJsonFormsLayoutProps(VerticalStepsLayout),
};
